import { render, staticRenderFns } from "./EpotQuestion.vue?vue&type=template&id=4c9e4804&"
import script from "./EpotQuestion.vue?vue&type=script&lang=js&"
export * from "./EpotQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports